import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import useViewCheckbook from 'src/hooks/useViewCheckbook';

const GLCodeDescription = (props: GridCellProps) => {
  const { isEditMode, hasEditGLCodePermission, isCheckbookEditable, isPeriodView, isYearEditable } =
    useViewCheckbook();
  const { dataItem, dataIndex, field, onChange } = props;
  const { value } = useGridCellDisplayValue(props);
  const { isDeleted, errors, warnings } = dataItem;
  const handleTextChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        syntheticEvent: e.syntheticEvent,
        field,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const hasEditPermission = useMemo(
    () => (isPeriodView ? isCheckbookEditable : isYearEditable),
    [isCheckbookEditable, isPeriodView, isYearEditable]
  );

  const isEditable = useMemo(
    () => isEditMode && hasEditGLCodePermission && !isDeleted && hasEditPermission,
    [hasEditGLCodePermission, hasEditPermission, isDeleted, isEditMode]
  );
  return (
    <GridCellBase
      {...props}
      title={value}
      className={`${
        errors?.description?.length
          ? '!bg-error-light'
          : warnings?.description?.length
          ? '!bg-warning-light'
          : ''
      } ${props.className}`}
      rowSelectionEnabled
    >
      {isEditable ? (
        <TextInput value={value} valid={!!value} onChange={handleTextChange} />
      ) : (
        <div className="flex items-center">
          <span className="text-ellipsis overflow-hidden">{value}</span>
          {isDeleted && <span className="bg-red-100 ml-2 text-red-700 p-1">Deleted</span>}
        </div>
      )}
    </GridCellBase>
  );
};

export default GLCodeDescription;
